import fetchAPI from '../fetchAPI';

interface CallGenerateBillProps {
  billingAccountId: string;
  endDate: string;
}

export const callGenerateBill = async ({
  billingAccountId,
  endDate
}: CallGenerateBillProps): Promise<iResponse<Bill>> => {
  const response: iResponse<Bill> = await fetchAPI({
    method: `POST`,
    route: `bills/generate`,
    data: { billingAccountId, endDate }
  });
  return response;
};

export default callGenerateBill;
